import SemrNotice from '@semcore/ui/notice';

export const Notice = SemrNotice;
